@if (auth.isLoading$ | async) {
<div class="spinner-border" role="status"></div>
} @else {
    @if (auth.isAuthenticated$ | async) {
        <div class="btn-group">
            <button type="button" class="btn btn-image dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <svg-icon name="user" svgClass="user-icon" [stretch]="true"></svg-icon>
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
                <li>
                    @if (isLoadingUserInformation$ | async) {
                        <div class="w-100 d-flex justify-content-center">
                            <div class="spinner-border" role="status"></div>
                        </div>
                    } @else {
                        <span class="px-2">{{fullName}}</span>
                        <div class="px-2">
                            @if (isSuperAdministrator) {
                            <ul class="role">
                                <li>Super Administrator</li>
                            </ul>
                            } @else {
                                @for (userRole of userRoles; track $index) {
                                <ul class="role">
                                    <li>
                                        <div>{{userRole.name}}</div>
                                    </li>
                                </ul>
                                }
                            }
                        </div>
                    }
                </li>
                <li>
                    <hr class="dropdown-divider">
                </li>
                <li><button class="dropdown-item" type="button"
                        (click)="logoutUser()">Logout</button>
                </li>
            </ul>
        </div>
    } @else {
        <button class="btn btn-dark-link" (click)="auth.loginWithRedirect()">Login</button>
    }
}
